<!-- /**
* 班组长详情页面
*/ -->
<template>
  <div class="ForemanDetail_page">
    <div class="leftBox">
      <div class="worker_text">
        <div class="top_title">
          <div class="pics">
            <img
              v-if="!workerDetail.avatarAddress"
              src="@/assets/public/gebilaowang.png"
              alt=""
            />
            <img v-else :src="workerDetail.avatarAddress" alt="" />
          </div>
          <div class="content">
            <div class="item_text">
              <div class="text_title">{{ workerDetail.name }}</div>
              <div class="sex">
                <img
                  v-if="workerDetail.sex == 0"
                  src="@/assets/worker/sex.png"
                  alt=""
                />
                <img v-else src="@/assets/worker/sexx.png" alt="" />
              </div>
              <div class="RealName" v-if="workerDetail.identity">已实名</div>
            </div>
            <div class="senced_text">
              <div class="item_age">
                {{ workerDetail.age ? workerDetail.age + "岁" : "" }}
              </div>
              <div class="line">|</div>
              <div style="marginRight: 10px" v-if="workerDetail.nationName">
                {{ workerDetail.nationName }}
              </div>
              <div class="phone">
                <span>联系电话：</span>
                <span v-if="workerDetail.contactPhone && !isCanLookPhone">
                  {{ starPhone(workerDetail.contactPhone) }}
                </span>
                <span v-if="workerDetail.contactPhone && isCanLookPhone">
                  {{ workerDetail.contactPhone }}
                </span>
                <span
                  v-if="workerDetail.contactPhone && !isCanLookPhone"
                  @click="queryContactType"
                  class="query-phone"
                  style="
                    color: #0099ff;
                    margin-left: 14px;
                    text-decoration: underline;
                    cursor: pointer;
                  "
                >
                  查看联系电话
                </span>
              </div>
            </div>
            <div class="three_text">
              <div
                class="evaluate"
                v-for="(item, index) in workerDetail.labelName"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="item_time">
            <div class="time">
              <span class="show">
                发布时间：
                {{ _updataTime(new Date(Number(workerDetail.createTime))) }}
              </span>
            </div>
            <div class="follows">
              <span
                @click="clickAttention(true)"
                v-if="!isAttention"
                class="attention-item"
              >
                <img src="@/assets/attention0.png" height="14" width="15" />
                <span>关 注</span>
              </span>
              <span
                @click="clickAttention(false)"
                v-else
                class="attention-item"
              >
                <img src="@/assets/attention1.png" height="14" width="16" />
                <span>已关注</span>
              </span>
            </div>
          </div>
        </div>
        <div class="worker_body">
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/gongzhong.png" alt="" />
                </span>
                <span>工种：</span>
                <span class="item_tag">{{ workerDetail.workTypeName }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/shuliandu.png" alt="" />
                </span>
                <span>熟练度：111</span>
                <span class="item_tag">
                  {{
                    workerDetail.proficiency
                      ? workerDetail.proficiency + "年"
                      : ""
                  }}
                </span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/gongling.png" alt="" />
                </span>
                <span>工龄：</span>
                <span class="item_tag">
                  {{
                    workerDetail.workingAge
                      ? `${workerDetail.workingAge}年`
                      : ""
                  }}
                </span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/zhuanye.png" alt="" />
                </span>
                <span>专业：</span>
                <span class="item_tag">{{ workerDetail.categoryName }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/address.png" alt="" />
                </span>
                <span>所在地区：</span>
                <span class="item_tag">{{
                  workerDetail.cityName ? workerDetail.cityName : ""
                }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/jiguan.png" alt="" />
                </span>
                <span>籍贯：</span>
                <span class="item_tag">{{ workerDetail.addressAll }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <div class="item_text single_hide">
                <span class="item_icon">
                  <img src="@/assets/worker/address.png" alt="" />
                </span>
                <span>希望工作地：</span>
                <span class="item_tag single_hide">{{
                  workerDetail.workAreaName ? workerDetail.workAreaName : ""
                }}</span>
              </div>
            </el-col>
          </el-row>
          <div class="tips">联系时，请说明是在“经营帮”上看到的</div>
        </div>
      </div>

      <div class="worker_introduction">
        <div class="dataList">
          <div class="title">
            <div class="name">班组介绍</div>
          </div>
          <div class="">
            <el-row :gutter="20" style="paddingtop: 5px">
              <el-col :span="24">
                <div class="item_texts single_hides">
                  <span class="item_icon">
                    <img src="@/assets/worker/gongzhong.png" alt="" />
                  </span>
                  <span>班组工种：</span>
                  <span class="single_hides">{{
                    workerDetail.leaderWorkTypeName
                  }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <div class="item_texts single_hides">
                  <span class="item_icon">
                    <img src="@/assets/worker/bz.png" alt="" />
                  </span>
                  <span>班组人数：</span>
                  <span class="single_hides">{{
                    workerDetail.classLeaderNum +
                      workerDetail.techWorkerNum +
                      workerDetail.ordinaryWorkerNum
                  }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="item_texts single_hides">
                  <span class="item_doc"></span>
                  <span>高级工(大工)：</span>
                  <span class="single_hides">{{
                    workerDetail.classLeaderNum
                      ? workerDetail.classLeaderNum + "人"
                      : ""
                  }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="item_texts single_hides">
                  <span class="item_doc"></span>
                  <span>中级工(中工)：</span>
                  <span class="single_hides">{{
                    workerDetail.techWorkerNum
                      ? workerDetail.techWorkerNum + "人"
                      : ""
                  }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="item_texts single_hides">
                  <span class="item_doc"></span>
                  <span>初级工(小工)：</span>
                  <span class="single_hides">{{
                    workerDetail.ordinaryWorkerNum
                      ? workerDetail.ordinaryWorkerNum + "人"
                      : ""
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="dataList">
          <div class="title">
            <div class="name">工作经验</div>
          </div>
          <div v-if="projectDetail.length > 0">
            <div
              class="experience"
              v-for="(item, index) in projectDetail"
              :key="index"
            >
              <div class="item_experience">
                <h3>{{ item.projectName }}</h3>
                <div class="item_adres">
                  <div class="timer">
                    {{ item.startTime ? dateFormat(item.startTime) + "~" : ""
                    }}{{ dateFormat(item.endTime) }}
                  </div>
                  <div>{{ item.provinceName }}{{ item.cityName }}</div>
                </div>
                <el-row :gutter="20">
                  <el-col>
                    <div class="item_flex">
                      <div class="flex_title">
                        <span>项目介绍：</span>
                      </div>
                      <div class="item_tag">
                        <span>{{ item.content }}</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col>
                    <div class="item_flex">
                      <div class="flex_title">
                        <span>施工图片：</span>
                      </div>
                      <div
                        class="item_pic"
                        v-for="(item, index) in item.filePath"
                        :key="index"
                      >
                        <img v-lazy="item" alt="" />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div
            v-else
            style="
              display: flex;
              align-items: center;
              flex-direction: column;
              padding: 20px 0;
            "
          >
            <img src="@/assets/zanwushuju-2@2x.png" alt="" />
            <p>暂无数据</p>
          </div>
        </div>

        <div class="dataList">
          <div class="title">
            <div class="name">资格证书</div>
          </div>
          <div class="itemList" v-if="imgList.length > 0">
            <div class="img-item">
              <div
                class="itemImg"
                v-for="(item, index) in imgList"
                :key="index"
              >
                <img v-lazy="item" alt />
              </div>
            </div>
          </div>
          <div
            v-else
            style="
              display: flex;
              align-items: center;
              flex-direction: column;
              padding: 20px 0;
            "
          >
            <img src="@/assets/zanwushuju-2@2x.png" alt="" />
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>
    <div class="rightBox">
      <div class="right_title">
        <div class="name">用工推荐</div>
      </div>
      <div v-for="(item, index) in recommendList" :key="index">
        <div class="recommend">
          <div class="recommend_item">
            <div class="gcName">
              {{ item.name ? item.name + "," + item.workTypeName : "" }}
            </div>
            <div class="gcTimer">
              {{ dateFormat(Number(item.publishTime)) }}
            </div>
          </div>
        </div>
      </div>
      <div class="rig_text">
        <div class="right_bottom">
          <div class="android">
            <div class="imgs">
              <img src="@/assets/fd/android.png" alt="" />
            </div>
            <span>安卓</span>
          </div>
          <div class="ios">
            <div class="imgs">
              <img src="@/assets/fd/ios.png" alt="" />
            </div>
            <span>ios</span>
          </div>
        </div>
        <p>扫描二维码下载经营部APP找工队、找劳务、找工人</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/http"
import { apiWorker } from "@/api/apiWorker"
// import { apiTalentsMess, getTeamType } from '@/api/apiTalentsMess'
import { apiResignAll } from "@/api/apiResignAll"
import link from "@/public/link.js"
import { formatDate2, NextDateTime } from "@/filters"
// import apiHelp from '@/api/apiHelp' // 临时做关注样式
import { mapState } from "vuex"
import cookie from "@/storage/cookies.js"
// import LeaseList from '@/views/RedesignTeamList/component/LeaseList' // 出租列表（文字格式）
// import Pagination from '@/views/Construction/components/Pagination'
const ERR_OK = 200 // 分页
export default {
  name: "workerDetail",
  props: {},
  data() {
    return {
      param: {
        page: 1,
        limit: 6,
        provinceNo: JSON.parse(cookie.cookieRead("area")).id
      },
      recommendList: [],
      // 是否关注
      isAttention: false,
      dialogFormVisible: false,
      workerDetail: {},
      projectDetail: [],
      imgList: [],
      mapCenter: [],
      mapPosition: [],
      text: {
        text: "",
        offset: [0, -50]
      },
      IsNoData: false,
      messageData: { isCompany: 1 },
      checkIndex: 0,
      phone: "",
      title: {
        name: "",
        updateTime: null
      },
      breadcrumbObj: {
        title: "当前位置：",
        fristName: "首页",
        fristPath: "/",
        secondName: "找工人",
        secondPath: "/worker",
        threeName: "找工人详情"
      },
      tab: [
        {
          name: "工程详情",
          show: true
        },
        {
          name: "团队要求",
          show: true
        }
      ],
      PersonMesaage: {
        type: "个人/企业均可",
        time: "2020.3.1-2020.8.1",
        sort: "10-30人",
        money: "50000元",
        startTime: "2020.5.1",
        sont: "市政公用工程专业丙级或以上地基资质",
        zont: "6%",
        equ:
          "需要团队提供挖掘机，平地机设备一台需要团队提供挖掘机，平地机设备一台需要团队提供挖掘机，平地...",
        mark:
          "联系我时，请说明是在施工邦上看到的！联系我时，请说明是在施工邦上看到的！联系我时，请说明是在..."
      },
      IsPerson: true,
      constructionTeamData: {},
      teamTypeData: [],
      teamSkillsData: [],
      rollScroll: false,

      performanceTeamList: [{}, {}, {}],
      performanceTitleList: [
        "项目名称",
        "工程地点",
        "业主/总包单位",
        "开工/竣工"
      ],
      performanceParam: {
        page: 1,
        limit: 20
      },

      personTeamList: [{}, {}, {}],
      personTitleList: ["姓名", "年龄", "工龄", "职位", "简介"],
      personParam: {
        page: 1,
        limit: 20
      },

      equTeamList: [{}, {}, {}],
      equTitleList: ["设备名称", "设备描述", "设备图片"],
      loadingTrue: false,
      noTextData: false,
      equParam: {
        page: 1,
        limit: 20
      },
      teamRequirementVO: {},
      engineeringInfoVO: {},
      RelevantData: {},
      isCanLookPhone: false
    }
  },
  components: {
    // LeaseList,
    // Pagination,
    // Breadcrumb: () => import('@/components/public/RedesignBreadcrumb'),
    // Tab: () => import('@/views/Construction/components/Tab'),
    // DetailsInner1: () =>
    //   import('@/views/Construction/components/DetailsInner1'),
    // DetailsInner2: () =>
    //   import('@/views/Construction/components/DetailsInner2'),
    // DetailsInner3: () =>
    //   import('@/views/Construction/components/DetailsInner3'),
    // DetailsInner4: () => import('@/views/Construction/components/DetailsInner4'),
    // mapdetail: () =>
    //   import('@/components/public/components/mapDetail')
  },
  watch: {},
  computed: {
    ...mapState({
      workerIndex: state => state.workerIndex
    })
  },
  created() {
    this.ForemanSearchList()
    const no = this.$route.params.id ? this.$route.params.id : ""
    if (no) {
      this.iniData(no)
    }
  },
  async mounted() {
    // await this.iniData(this.$route.query.id)
    window.addEventListener("scroll", this.menu)
  },
  methods: {
    NextDateTime,
    ChangeType(engineeringInfoVO) {
      const string = `${
        engineeringInfoVO.firstCategoryName
          ? engineeringInfoVO.firstCategoryName
          : ""
      }${
        engineeringInfoVO.secondCategoryName
          ? "/" + engineeringInfoVO.secondCategoryName
          : ""
      }${
        engineeringInfoVO.thirdCategoryName
          ? "/" + engineeringInfoVO.thirdCategoryName
          : ""
      }`
      return string
    },
    showMap() {
      this.dialogFormVisible = true
    },
    // 隐藏号码中间4位数
    starPhone(phoneNum) {
      let str = String(phoneNum)
      return str.substr(0, 3) + "****" + str.substr(7)
    },
    // 点击关注
    clickAttention(state) {
      let token = this.$store.state.token
      if (!token) {
        let data = {
          callBack: function() {
            this.$store.dispatch("setUser")
          }.bind(this)
        }
        this.$_login(data)
      } else {
        let no = this.$route.params.id
        let type = 3
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        apiResignAll
          .addAttention(no, type)
          .then(res => {
            if (res.data && res.data.code === 200) {
              this.isAttention = state
              if (state) {
                this.$message.success("关注成功")
              } else {
                this.$message.success("取消关注成功")
              }
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
      }
    },
    /** @name 在线咨询 */
    OnlineConsulting() {
      if (this.$store.state.loginType) {
        if (this.workerDetail.imId) {
          axios
            .get(
              process.env.VUE_APP_APITEAM +
                "/consultation?id=" +
                this.workerDetail.imId
            )
            .then(res => {
              if (res.data.code === ERR_OK) {
                this.$store.commit("SET_ISOPEN", true)
                this.$store.commit("SETTOUSER", res.data.data.imAccount)
              } else {
                this.$message.error(res.data.msg)
              }
            })

        } else {
          this.$message.error("未设置客服人员，不支持咨询！")
        }
      } else {
        this.loginIndex()
      }
    },

    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    setLi1() {
      let str = this.constructionTeamData.introduce
      // let i = 1
      let arr = str.split("<li>")
      let str2 = ""
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          str2 = str2 + arr[i]
          continue
        }
        str2 = str2 + `<li><span>${i}、 </span>` + arr[i]
      }
      this.constructionTeamData.introduce = str2
    },
    setLi2() {
      let str = this.constructionTeamData.performance
      // let i = 1
      let arr = str.split("<li>")
      let str2 = ""
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          str2 = str2 + arr[i]
          continue
        }
        str2 = str2 + `<li><span>${i}、 </span>` + arr[i]
      }
      this.constructionTeamData.performance = str2
    },
    setLi3() {
      let str = this.constructionTeamData.equipment
      // let i = 1
      let arr = str.split("<li>")
      let str2 = ""
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          str2 = str2 + arr[i]
          continue
        }
        str2 = str2 + `<li><span>${i}、 </span>` + arr[i]
      }
      this.constructionTeamData.equipment = str2
    },
    formatDate2,
    computedP() {
      let infobox = document.getElementsByClassName("p_content")
      Array.from(infobox).forEach(element => {
        if (element.offsetHeight < 93) {
          element.nextSibling.style.display = "none"
        } else {
          element.style.height = "96px"
        }
      })
    },
    hasClass(_classList, _className) {
      if (_classList.indexOf(_className) !== -1) {
        return true
      } else {
        return false
      }
    },
    targetOpen(e) {
      const currentTarget = e.currentTarget
      const child = currentTarget.parentNode.children
      const parent = currentTarget.parentNode
      const previous = currentTarget.parentNode.previousSibling
      if (this.hasClass(previous.className, "ellipsis4")) {
        previous.classList.remove("ellipsis4")
        previous.style.height = "auto"
        child[0].innerHTML = "点击收起"
        child[1].classList.remove("el-icon-caret-bottom")
        child[1].classList.add("el-icon-caret-top")
        parent.classList.add("isopen")
      } else {
        previous.classList.add("ellipsis4")
        previous.style.height = "96px"
        child[0].innerHTML = "点击展开"
        child[1].classList.remove("el-icon-caret-top")
        child[1].classList.add("el-icon-caret-bottom")
        parent.classList.remove("isopen")
      }
    },
    tel(telNum) {
      if (telNum) {
        let ary = telNum.split("")
        ary.splice(3, 4, "****")
        return ary.join("")
      }
      return ""
    },
    checkContactway() {
      if (this.$store.state.loginType) {
        this.constructionTeamData.concatPhone = this.phone
      } else {
        link.login()
      }
    },
    /** @name 获取详情数据 */
    async iniData(no) {
      let res = await apiWorker.getForemanDetail(no)
      this.workerDetail = res.data.data
      if (this.workerDetail.isFocus) {
        this.isAttention = true
      } else {
        this.isAttention = false
      }

      this.projectDetail = res.data.data.workExpList
      this.imgList = this.workerDetail.filePath
    },
    /** @name 获取班组长列表6条数据 */
    async ForemanSearchList() {
      let res = await apiWorker.ForemanSearchList(this.param)
      if (res.data && res.data.code === 200) {
        this.recommendList = res.data.data.records
      }
    },
    check(index) {
      this.checkIndex = index
    },
    changeRollScroll(bol) {
      this.rollScroll = bol
    },
    menu() {},
    getShowTab() {},
    // 点击'查看联系方式'按钮
    queryContactType() {
      let token = this.$store.state.token
      if (!token) {
        this.loginIndex()
      } else {
        this.isCanLookPhone = true
      }
    }
  },

  destroyed() {
    window.removeEventListener("scroll", this.menu)
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
// @import "~@/styles/variable.scss";
div {
  box-sizing: border-box;
}
.ForemanDetail_page {
  padding: 10px 0;
  width: 1200px;
  font-size: 14px;
  color: #333;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .leftBox {
    width: 890px;
    .worker_text {
      background: #fff;
      .top_title {
        display: flex;
        justify-content: flex-start;
        padding: 10px;
        .pics {
          width: 110px;
          height: 110px;
          margin-right: 10px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        .content {
          .item_text {
            height: 25px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .text_title {
              font-size: 24px;
              font-weight: bold;
            }
            .sex {
              margin: 0 10px;
            }
            .RealName {
              width: 44px;
              height: 20px;
              background: #0286df;
              border-radius: 2px;
              color: #fff;
              font-size: 14px;
              text-align: center;
              line-height: 20px;
            }
          }
          .senced_text {
            display: flex;
            align-items: center;
            padding: 20px 0;
            .line {
              margin: 0 10px;
            }
            .phone {
              // margin-left: 20px;
            }
          }
          .three_text {
            display: flex;
            color: #409ee9;
            opacity: 1;
            .evaluate {
              margin-right: 10px;
              width: 78px;
              height: 30px;
              background: rgba(64, 158, 233, 0.1);
              text-align: center;
              line-height: 30px;
            }
          }
        }
        .item_time {
          padding-left: 240px;
          .follows {
            font-size: 14px;
            color: #666666;
            padding-left: 77px;
            .attention-item {
              cursor: pointer;
              height: 36px;
              line-height: 36px;
              img {
                margin-right: 10px;
                position: relative;
                top: 2px;
              }
            }
          }
        }
      }
      .worker_body {
        margin-top: 10px;
        .single_hide {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item_text {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 45px;
          display: flex;
          align-items: center;
          .item_icon {
            width: 24px;
            height: 24px;
            padding: 0 20px;
          }
        }
        .tips {
          font-size: 12px;
          color: #969696;
          padding-bottom: 20px;
          padding-left: 20px;
        }
      }
    }
    .worker_introduction {
      margin-top: 10px;
      background: #fff;
      .dataList {
        padding: 10px 20px;
        > .title {
          display: flex;
          align-items: center;
          height: 45px;
          border-bottom: 1px dashed #eee;
          .name {
            font-size: 18px;
            color: #0286df;
            font-weight: 400;
            line-height: 23px;
            border-left: 3px solid #0286df;
            padding-left: 10px;
          }
        }
        .single_hides {
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .item_doc {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          border-color: #0286df;
          background: #0286df;
          margin-right: 5px;
        }
        .item_texts {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
          display: flex;
          align-items: center;
          .item_icon {
            width: 24px;
            height: 24px;
            padding: 0 5px;
          }
        }
        .img-item {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .itemImg {
            width: 205px;
            height: 205px;
            padding: 20px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .experience {
          padding: 20px;
          background: #f5f7fa;
          margin-bottom: 10px;
          .item_experience {
            .item_adres {
              display: flex;
              padding: 10px 0;
              .timer {
                margin-right: 40px;
              }
            }
          }
          .item_flex {
            display: flex;
            .flex_title {
              width: 70px;
            }
            .item_tag {
              flex: 1;
            }
            .item_pic {
              margin-right: 10px;
              width: 80px;
              height: 80px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
  .rightBox {
    width: 300px;
    padding-left: 19px;
    .right_title {
      padding: 10px 10px;
      background-color: #fff;
      .name {
        font-size: 18px;
        font-weight: 400;
        line-height: 23px;
        border-left: 3px solid #0286df;
        padding-left: 10px;
        color: #0286df;
      }
    }
    .recommend {
      background-color: #fff;
      padding: 5px 10px;
      border-bottom: 1px solid #eee;
      .recommend_item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 0;
        .gcName {
          width: 150px;
          color: #333;
          font-size: 14px;
          // 单行隐藏
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .gcTimer {
          // flex: 1;
          color: #969696;
          font-size: 14px;
        }
      }
    }
    .rig_text {
      background-color: #fff;
      color: #333;
      padding: 20px 0;
      .right_bottom {
        background-color: #fff;
        width: 100%;
        margin-top: 10px;
        display: flex;
        justify-content: space-evenly;
        color: #333333;
        font-size: 14px;
        padding-top: 30px;
        margin-bottom: 10px;
        .android {
          text-align: center;
          .imgs {
            width: 78px;
            height: 78px;
            margin-bottom: 10px;
            border: 1px solid #333;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .ios {
          text-align: center;
          .imgs {
            width: 78px;
            height: 78px;
            margin-bottom: 10px;
            border: 1px solid #333;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      p {
        width: 214px;
        margin: 0 auto;
        text-align: center;
      }
    }
  }
}
</style>
